import { Attachment } from '../interfaces/attachment.interface';

export const mockAttachment: Attachment = {
  id: '45a4695b-996d-47ef-9491-0754646581d5',
  fileName: 'satellite.pdf',
  fileType: 'application/pdf',
  fileSize: 3423465,
  fileUrl: 'https://some.server/url/satellite.pdf',
};
